import type {Repository} from '@github-ui/current-repository'
import {pullRequestPath} from '@github-ui/paths'
import {Link as RouterLink} from '@github-ui/react-router'
import {canSoftNavToCodeView, isPullRequestsEnabled} from '@github-ui/repo-app-flags'
import {GitPullRequestIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'

import styles from './PullRequestLink.module.css'

interface Props {
  repo: Repository
  pullRequestNumber: number
}

export function PullRequestLink({repo, pullRequestNumber}: Props) {
  const path = pullRequestPath({repo, number: pullRequestNumber})

  // Soft-navigate only when both the current (code view) and destination (pull requests) apps are
  // mounted in the repo app; otherwise fall back to a full-page navigation.
  if (canSoftNavToCodeView() && isPullRequestsEnabled()) {
    return (
      <Link as={RouterLink} to={path} className={styles.Link}>
        <GitPullRequestIcon size={16} />#{pullRequestNumber}
      </Link>
    )
  }

  return (
    <Link href={path} className={styles.Link}>
      <GitPullRequestIcon size={16} />#{pullRequestNumber}
    </Link>
  )
}
